import { render, staticRenderFns } from "./InfoPv.vue?vue&type=template&id=71d7dddd&scoped=true&"
import script from "./InfoPv.vue?vue&type=script&lang=js&"
export * from "./InfoPv.vue?vue&type=script&lang=js&"
import style0 from "./InfoPv.vue?vue&type=style&index=0&id=71d7dddd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7dddd",
  null
  
)

export default component.exports